module.exports = function (unsubscribeEdmService, settings, $state, $timeout) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            scope.messages = {};

            function _init() {
                if (!$state.params.token) {
                    if (!$state.params.shopperID) {
                        $state.go('root');
                    } else if (!$state.params.checksum) {
                        $state.go('error.404', null, { location: 'replace' });
                    }
                }

                scope.settings = settings;

                unsubscribeEdmService.unsubscribeEDM($state.params.shopperID, $state.params.token, $state.params.checksum, $state.params.documentID).then((response) => {
                    if (response.ShouldRedirectToHomePage) {
                        $state.go('root');
                    }

                    scope.unsubscribeData = response;

                    // Preset the checkboxes after content on page has loaded
                    $timeout(() => {
                        if (!scope.unsubscribeData.IsAlreadyUnsubscribed) {
                            scope.choice = 'Yes';
                        }
                    });
                });
            }

            scope.continue = function () {
                scope.unsubscribeData.Confirm = scope.choice;
                unsubscribeEdmService.unsubscribeEDMConfirmation(scope.unsubscribeData).then((response) => {
                    if (response.ShouldRedirectToHomePage) {
                        $state.go('root');
                    }

                    scope.unsubscribeData = response;
                });
            };

            scope.toggleChoice = function (choice) {
                scope.choice = choice;
            };

            scope.showUnsubscribeConfirmation = function () {
                return scope.unsubscribeData && !scope.unsubscribeData.Successful && !scope.unsubscribeData.IsAlreadyUnsubscribed;
            };

            _init();
        },
        template: require('./unsubscribe-edm-v2.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/common/unsubscribeedm/unsubscribe-edm.directive.js